import { useWSMutation } from "../../helpers";
import { QUERY_SHARED_FILE } from "../keys";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { WSServiceError } from "../../../utils/serviceHelper";
import { submitSharedFile } from "../../../services/sharedFile/submitSharedFile";
import { QUERY_NOTIFICATIONS_NOTIFICATIONS } from "../../notifications/keys";

type SubmitSharedFilePayload = {
  sharedFileId: string;
};

export const useMutationSubmitSharedFile = () =>
  useWSMutation<
    ISharedFileRequestResponse,
    WSServiceError,
    SubmitSharedFilePayload
  >(({ sharedFileId }) => submitSharedFile(sharedFileId), {
    dependencies(payload) {
      return [
        [QUERY_SHARED_FILE, payload.sharedFileRequestId],
        [QUERY_NOTIFICATIONS_NOTIFICATIONS]
      ];
    }
  });
